import { NewsCategoryRequest, NewsCategoryResponse } from '../dto/categories';
import { NewsTranslationTitleRequest, NewsTranslationTitleResponse } from '../dto/news-titles';
import { NewsTranslationContentRequest, NewsTranslationContentResponse } from '../dto/news-content';
import { httpArg, httpGet, httpRoute, optionalHttpUserId } from '../infrastructure/http/http-decorators';

/**
 * Service for accessing news content.
 * Provides categories, news titles, and full article content.
 */
@httpRoute('/api/news-content')
export abstract class INewsContentService {
	/**
	 * Get available news categories
	 */
	@httpGet('get-categories')
	getCategories(
		@httpArg('request') request: NewsCategoryRequest,
		@optionalHttpUserId() userId?: string
	): Promise<NewsCategoryResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Get news article titles/list for a category
	 */
	@httpGet('get-news')
	getNewsTranslations(
		@httpArg('request') request: NewsTranslationTitleRequest,
		@optionalHttpUserId() userId?: string
	): Promise<NewsTranslationTitleResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Get full content for a specific article
	 */
	@httpGet('get-content')
	getContent(@httpArg('request') request: NewsTranslationContentRequest): Promise<NewsTranslationContentResponse> {
		void request;
		throw new Error('Not implemented');
	}
}
